export const CARD_MAX_WIDTH = 600
